import { getActiveDriverIds } from "@/lib/drivers/active-profiles"
let driverIdsCache: Set<string> | null = null
let lastCacheUpdate = 0
const CACHE_TTL = 86400 * 1000
;(async function initializeCache() {
  try {
    const activeDrivers = await getActiveDriverIds()
    driverIdsCache = new Set(activeDrivers.map((driver) => driver.ID))
    lastCacheUpdate = Date.now()
  } catch (error) {
    console.error("Error initializing driver IDs cache:", error)
  }
})()
export async function isValidDriverIdAsync(
  id?: string | number,
): Promise<boolean> {
  if (!id) return false
  const driverId = String(id)
  const now = Date.now()
  if (!driverIdsCache || now - lastCacheUpdate > CACHE_TTL) {
    try {
      const activeDrivers = await getActiveDriverIds()
      driverIdsCache = new Set(activeDrivers.map((driver) => driver.ID))
      lastCacheUpdate = now
    } catch (error) {
      console.error("Error validating driver ID:", error)
      return false
    }
  }
  return driverIdsCache.has(driverId)
}
export function isValidDriverId(id?: string | number): boolean {
  if (!id) return false
  const driverId = String(id)
  if (!driverIdsCache) {
    return true
  }
  return driverIdsCache.has(driverId)
}
